'use strict';

;( () => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'shySiteHeader', () => ({
			currentScrollTop: 0,
			headerHeight    : document.querySelector( '#page > div' ).offsetHeight,
			isScrollingDown : false,
			isScrollingUp   : false,
			lastScrollTop   : 0,

			handleScroll() {
				this.currentScrollTop = window.scrollY || document.documentElement.scrollTop;
				this.isScrollingUp    = this.currentScrollTop < this.lastScrollTop;
				this.isScrollingDown  = this.currentScrollTop > this.lastScrollTop;

				if ( 0 >= this.currentScrollTop ) {
					this.lastScrollTop = 0;
				} else {
					this.lastScrollTop = this.currentScrollTop;
				}
			}
		}) );
	});
})();
